import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchTrackingMetrics } from "../../../store/slices/reportSlice";
import TrackingMetricsList from "./TrackingMetricsList";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import MainLayout from "../../../components/layout/MainLayout";

const TrackingMetricsReports = () => {
  const dispatch = useDispatch();
  const { trackingMetrics, trackingSummary, isLoading } = useSelector((state) => state.reports);

  const [showFilters, setShowFilters] = useState(false);
  const [tempFilters, setTempFilters] = useState({
    year: "2026",
    category: ""
  });

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: '31px',
      height: '31px',
      fontSize: '0.8125rem',
      borderRadius: '0.375rem',
      borderColor: '#d9dee3',
      '&:hover': { borderColor: '#d9dee3' }
    }),
    valueContainer: (base) => ({ ...base, padding: '0 8px', height: '31px' }),
    input: (base) => ({ ...base, margin: '0', padding: '0' }),
    indicatorsContainer: (base) => ({ ...base, height: '31px' }),
    dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
    clearIndicator: (base) => ({ ...base, padding: '2px' }),
    menu: (base) => ({ ...base, fontSize: '0.8125rem' }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#666ee8' : state.isFocused ? '#f5f5f9' : 'white',
      color: state.isSelected ? 'white' : '#566a7f',
      cursor: 'pointer',
    })
  };

  const yearOptions = [
    { value: "2024", label: "2024" },
    { value: "2025", label: "2025" },
    { value: "2026", label: "2026" },
  ];

  const categoryOptions = [
    { value: "", label: "All Categories" },
    { value: "Total Inquiries", label: "Total Inquiries" },
    { value: "Residential Patients", label: "Residential Patients" },
    { value: "Day Rehab Patients", label: "Day Rehab Patients" },
    { value: "Home Visitation Patients", label: "Home Visitation Patients" },
    { value: "Total Escorts", label: "Total Escorts" },
  ];
  const [activeFilters, setActiveFilters] = useState({
    year: "2026",
    category: ""
  });

  useEffect(() => {
    dispatch(fetchTrackingMetrics(activeFilters));
  }, [dispatch, activeFilters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setTempFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    setActiveFilters({ ...tempFilters });
  };

  const handleClear = () => {
    const cleared = {
      year: "2026",
      category: ""
    };
    setTempFilters(cleared);
    setActiveFilters(cleared);
  };

  return (
    <MainLayout>
      <Breadcrumbs />
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Tracking Metrics Report</h4>
          <div>
            <button
              className={`btn btn-sm ${showFilters ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setShowFilters(!showFilters)}
            >
              <i className="ri-filter-line me-1"></i> {showFilters ? 'Hide Filters' : 'Filters'}
            </button>
          </div>
        </div>

        {/* Filters Accordion */}
        <div className={`collapse ${showFilters ? 'show' : ''}`}>
          <div className="px-4 py-3">
            <div className="card shadow-sm border">
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Year</label>
                    <Select
                      options={yearOptions}
                      styles={selectStyles}
                      value={yearOptions.find(opt => opt.value === tempFilters.year)}
                      onChange={(opt) => setTempFilters(prev => ({ ...prev, year: opt.value }))}
                      placeholder="Select Year"
                      isSearchable
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Category</label>
                    <Select
                      options={categoryOptions}
                      styles={selectStyles}
                      value={categoryOptions.find(opt => opt.value === tempFilters.category)}
                      onChange={(opt) => setTempFilters(prev => ({ ...prev, category: opt.value }))}
                      placeholder="Select Category"
                      isSearchable
                    />
                  </div>
                  <div className="col-md-4 d-flex align-items-end gap-2">
                    <button className="btn btn-sm btn-label-secondary w-50" onClick={handleClear}>Clear</button>
                    <button className="btn btn-sm btn-primary w-50" onClick={handleSubmit}>Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <TrackingMetricsList
          data={trackingMetrics}
          summary={trackingSummary}
          filters={activeFilters}
          isLoading={isLoading}
        />
      </div>
    </MainLayout>
  );
};

export default TrackingMetricsReports;
